import { Box, Typography } from "@mui/material";

// export const getLocationContent = (
//   location,
//   t,
//   textStyles,
//   showGoogleMapIcon = false,
//   addLink = false,
//   onAddLinkClick
// ) => {
//   const { client_address, online, business_address } = location || {};

//   const hasClient = !!client_address;
//   const hasOnline = !!online;
//   const hasBusiness = !!business_address;

//   const activeLocations = [];

//   if (hasClient) activeLocations.push(t("client_address"));
//   if (hasOnline) activeLocations.push(t("online"));
//   if (hasBusiness) activeLocations.push(t("business_address"));

//   let displayText = "";

//   if (hasClient && !hasOnline && !hasBusiness) {
//     displayText = client_address;
//   } else if (!hasClient && !hasOnline && hasBusiness) {
//     displayText = t("business_address");
//   } else if (!hasClient && hasOnline && !hasBusiness) {
//     displayText = t("online");
//   } else if (activeLocations.length > 1) {
//     const parts = [];
//     if (hasOnline) parts.push(t("online"));
//     if (hasBusiness)
//       parts.push(
//         showGoogleMapIcon && hasClient
//           ? t("at_business")
//           : t("business_address")
//       );
//     if (hasClient) parts.push(t("client_address"));

//     displayText = parts.join(` ${t("or")} `);
//   } else {
//     displayText = "";
//   }

//   let tooltipText = "";

//   if (hasClient && !hasOnline && !hasBusiness) {
//     tooltipText = client_address;
//   } else {
//     tooltipText = null;
//   }

//   if (!tooltipText)
//     return (
//       <Box sx={{ display: "flex", alignItems: "center" }}>
//         <Typography
//           sx={{
//             fontSize: "14px",
//             color: "rgba(72, 72, 72, 1)",
//             fontWeight: 400,
//             width: "max-content",
//             ...textStyles,
//           }}
//         >
//           {displayText}
//         </Typography>

//         {showGoogleMapIcon && client_address ? (
//           <Box
//             component="a"
//             href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//               client_address
//             )}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             sx={{ display: "flex", cursor: "pointer", ml: "5px" }}
//           >
//             <img src="/icons/google-maps-logo.svg" alt="google-maps-logo" />
//           </Box>
//         ) : null}

//         {addLink && online ? (
//           <Box
//             onClick={onAddLinkClick}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: "2px",
//               cursor: "pointer",
//               ml: "8px",
//             }}
//           >
//             <img src="/icons/link-icon.svg" alt="link-icon" />
//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 color: "rgba(37, 124, 109, 1)",
//                 fontWeight: 600,
//                 textDecoration: "underline",
//               }}
//             >
//               {t("add_link")}
//             </Typography>
//           </Box>
//         ) : null}
//       </Box>
//     );

//   return (
//     <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
//       <CustomTooltip title={tooltipText} tooltipSxStyles={{ paddingY: "5px" }}>
//         <Typography
//           sx={{
//             fontSize: "14px",
//             color: "rgba(72, 72, 72, 1)",
//             fontWeight: 400,
//             width: "max-content",
//             ...textStyles,
//           }}
//         >
//           {displayText.length > 25
//             ? displayText.slice(0, 25) + "..."
//             : displayText}
//         </Typography>
//       </CustomTooltip>

//       {showGoogleMapIcon && client_address ? (
//         <Box
//           component="a"
//           href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//             client_address
//           )}`}
//           target="_blank"
//           rel="noopener noreferrer"
//           sx={{ display: "flex", cursor: "pointer" }}
//         >
//           <img src="/icons/google-maps-logo.svg" alt="google-maps-logo" />
//         </Box>
//       ) : null}
//     </Box>
//   );
// };

export const getLocationContent = (
  location,
  t,
  textStyles,
  showGoogleMapIcon = false,
  onAddLinkClick,
  abbreviateAddress = false,
  hasExistingLink = false,
) => {
  if (!location) return "-";

  // Normalise to a string regardless of whether the API returns a string,
  // an array of strings, or the legacy object { client_address, online, business_address }
  let locationString;
  if (Array.isArray(location)) {
    locationString = location.join(" or ");
  } else if (typeof location === "object") {
    const { client_address, online, business_address } = location;
    const parts = [];
    if (online) parts.push("online");
    if (business_address) parts.push("business address");
    if (client_address) parts.push(client_address);
    locationString = parts.join(" or ");
  } else {
    locationString = location;
  }

  if (!locationString) return "-";

  const parts = locationString.split(" or ");
  const hasMultipleLocations = parts.length > 1;
  const hasOnline = parts.some((p) => p.trim().toLowerCase() === "online");

  const translatedParts = parts.map((part) => {
    const value = part.trim().toLowerCase();

    if (value === "online") return t("online");
    if (value === "business address") return t("business_address");
    if (value === "client address") return t("client_address");

    // For pending/missed jobs, abbreviate to "Client Address (city)"
    if (abbreviateAddress) {
      const addressParts = part.split(",").map((s) => s.trim()).filter(Boolean);
      const city = addressParts.length >= 3
        ? addressParts[addressParts.length - 2]  // "Street, City, Country" → City
        : addressParts.length === 2
          ? addressParts[0]  // "City, Country" → City
          : null;
      return city ? `${t("client_address")} (${city})` : t("client_address");
    }

    // Full address for active/completed jobs
    return part;
  });

  const displayText = translatedParts.join(` ${t("or")} `);

  const mapAddress = parts.find((part) => {
    const value = part.trim().toLowerCase();
    return value !== "online" && value !== "business address" && value !== "client address";
  });

  const showMap = showGoogleMapIcon && mapAddress;
  const showAddLink = hasOnline && onAddLinkClick;

  return (
    <Box>
      <Typography
        component="span"
        sx={{
          fontSize: "14px",
          color: "rgba(72,72,72,1)",
          fontWeight: 400,
          wordBreak: "break-word",
          ...textStyles,
        }}
      >
        {displayText}
      </Typography>

      {showMap && (
        <Box
          component="a"
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            mapAddress,
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ display: "inline-flex", verticalAlign: "middle", cursor: "pointer", mx: "5px" }}
        >
          <img src="/icons/google-maps-logo.svg" alt="google-maps-logo" />
        </Box>
      )}

      {showAddLink && (
        <Box
          component="span"
          onClick={onAddLinkClick}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "2px",
            cursor: "pointer",
            verticalAlign: "middle",
          }}
        >
          <img src="/icons/link-icon.svg" alt="link-icon" />
          <Typography
            component="span"
            sx={{
              fontSize: "14px",
              color: "rgba(37, 124, 109, 1)",
              fontWeight: 600,
              textDecoration: "underline",
            }}
          >
            {hasExistingLink ? t("edit_link") : t("add_link")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
